module.exports = __webpack_public_path__ + "img/some1.ccc5f42a.png";